/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ImageThumbnail,
    ImageThumbnailFromJSON,
    ImageThumbnailFromJSONTyped,
    ImageThumbnailToJSON,
    User,
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
} from './';

/**
 * 
 * @export
 * @interface Image
 */
export interface Image {
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    fileName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    imageData?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    contentType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    createdBy?: string;
    /**
     * 
     * @type {Date}
     * @memberof Image
     */
    createdDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    modifiedBy?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof Image
     */
    modifiedDate?: Date | null;
    /**
     * 
     * @type {User}
     * @memberof Image
     */
    creator?: User;
    /**
     * 
     * @type {User}
     * @memberof Image
     */
    modifier?: User;
    /**
     * 
     * @type {Array<ImageThumbnail>}
     * @memberof Image
     */
    imageThumbnails?: Array<ImageThumbnail> | null;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    id?: string;
}

export function ImageFromJSON(json: any): Image {
    return ImageFromJSONTyped(json, false);
}

export function ImageFromJSONTyped(json: any, ignoreDiscriminator: boolean): Image {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
        'imageData': !exists(json, 'imageData') ? undefined : json['imageData'],
        'contentType': !exists(json, 'contentType') ? undefined : json['contentType'],
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'createdDate': !exists(json, 'createdDate') ? undefined : (new Date(json['createdDate'])),
        'modifiedBy': !exists(json, 'modifiedBy') ? undefined : json['modifiedBy'],
        'modifiedDate': !exists(json, 'modifiedDate') ? undefined : (json['modifiedDate'] === null ? null : new Date(json['modifiedDate'])),
        'creator': !exists(json, 'creator') ? undefined : UserFromJSON(json['creator']),
        'modifier': !exists(json, 'modifier') ? undefined : UserFromJSON(json['modifier']),
        'imageThumbnails': !exists(json, 'imageThumbnails') ? undefined : (json['imageThumbnails'] === null ? null : (json['imageThumbnails'] as Array<any>).map(ImageThumbnailFromJSON)),
        'id': !exists(json, 'id') ? undefined : json['id'],
    };
}

export function ImageToJSON(value?: Image | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'fileName': value.fileName,
        'imageData': value.imageData,
        'contentType': value.contentType,
        'createdBy': value.createdBy,
        'createdDate': value.createdDate === undefined ? undefined : (value.createdDate.toISOString()),
        'modifiedBy': value.modifiedBy,
        'modifiedDate': value.modifiedDate === undefined ? undefined : (value.modifiedDate === null ? null : value.modifiedDate.toISOString()),
        'creator': UserToJSON(value.creator),
        'modifier': UserToJSON(value.modifier),
        'imageThumbnails': value.imageThumbnails === undefined ? undefined : (value.imageThumbnails === null ? null : (value.imageThumbnails as Array<any>).map(ImageThumbnailToJSON)),
        'id': value.id,
    };
}


